<pbc-filter-preset
  [filter]="durchsuchen.preset$ | async"
  [filters]="durchsuchen.presets$ | async"
  [name]="durchsuchen.search$ | async"
  (select)="durchsuchen.setFilter($event)"
  (save)="durchsuchen.writeFilter($event)"
  (delete)="durchsuchen.deleteFilter($event)"
></pbc-filter-preset>
